export * from './src/bookings-v2-price-info-pricing.universal.js';
